"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[609],{

/***/ 88854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ SelectField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37328);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76699);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63955);
/* harmony import */ var _brand_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18381);
/* harmony import */ var hooks_form_useErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41217);
/* harmony import */ var hooks_form_useStyles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16567);
/* harmony import */ var components_utils_IsVisible__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92238);










var SelectField = function(param) {
    var defaultValue = param.defaultValue, field = param.field, id = param.id, isDisabled = param.isDisabled, name = param.name;
    var label = field.label, isRequired = field.isRequired, shouldDisplay = field.shouldDisplay, _styles = field.styles, styles = _styles === void 0 ? {} : _styles, handleChange = field.handleChange;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)("form").t;
    var ref = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useFormContext */ .Gc)(), register = ref.register, watch = ref.watch;
    var fieldStyles = (0,hooks_form_useStyles__WEBPACK_IMPORTED_MODULE_3__/* .useStyles */ .y)("selectField", styles);
    var errorMessage = (0,hooks_form_useErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* .useErrorMessage */ .f)(name, label);
    var values = watch(name);
    var isVisible = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return shouldDisplay ? shouldDisplay(values) : true;
    }, [
        values,
        shouldDisplay
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_utils_IsVisible__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        when: isVisible,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .FormControl */ .NI, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            isInvalid: !!errorMessage,
            isRequired: isRequired,
            onChange: handleChange
        }, fieldStyles.control), {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_utils_IsVisible__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    when: !!label,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .FormLabel */ .lX, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        htmlFor: name,
                        variant: "proRikApp"
                    }, fieldStyles.label), {
                        children: label
                    }))
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Select */ .Ph, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                    "data-testid": id,
                    defaultValue: defaultValue || field.defaultValue,
                    variant: "proRikApp"
                }, register(name), fieldStyles.select), {
                    disabled: isDisabled || false,
                    children: field.options.map(function(option, index) {
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("option", {
                            style: index % 2 === 0 ? {
                                fontSize: "16px",
                                backgroundColor: "#F4F8FB"
                            } : {
                                fontSize: "16px"
                            },
                            value: option.value,
                            children: option.label || option.value
                        }, option.value);
                    })
                })),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_utils_IsVisible__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    when: !!errorMessage,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .FormErrorMessage */ .J1, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, fieldStyles.errorMessage), {
                        children: t("validations.".concat(errorMessage))
                    }))
                })
            ]
        }), "".concat(name, "-control"))
    });
};


/***/ }),

/***/ 34732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(37328);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96670);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52903);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76699);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63955);
/* harmony import */ var _brand_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18381);
/* harmony import */ var hooks_form_useErrorMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41217);
/* harmony import */ var hooks_form_useStyles__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16567);
/* harmony import */ var components_utils_IsVisible__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92238);










var TextField = function(param) {
    var field = param.field, id = param.id, name = param.name;
    var label = field.label, placeholder = field.placeholder, htmlInputType = field.htmlInputType, isRequired = field.isRequired, isDisabled = field.isDisabled, value = field.value, shouldDisplay = field.shouldDisplay, _styles = field.styles, styles = _styles === void 0 ? {} : _styles;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)("form").t;
    var fieldStyles = (0,hooks_form_useStyles__WEBPACK_IMPORTED_MODULE_3__/* .useStyles */ .y)("textField", styles);
    var watch = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .useFormContext */ .Gc)().watch;
    var errorMessage = (0,hooks_form_useErrorMessage__WEBPACK_IMPORTED_MODULE_2__/* .useErrorMessage */ .f)(name, label);
    var values = watch(name);
    var isVisible = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return shouldDisplay ? shouldDisplay(values) : true;
    }, [
        values,
        shouldDisplay
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_utils_IsVisible__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        when: isVisible,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .FormControl */ .NI, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
            isInvalid: !!errorMessage,
            isRequired: isRequired
        }, fieldStyles.control), {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_utils_IsVisible__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    when: !!label,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .FormLabel */ .lX, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        htmlFor: name,
                        marginBottom: "4px",
                        variant: "proRikApp"
                    }, fieldStyles.label), {
                        children: label
                    }))
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(react_hook_form__WEBPACK_IMPORTED_MODULE_5__/* .Controller */ .Qr, {
                    defaultValue: value || "",
                    name: name,
                    render: function(param) {
                        var field = param.field;
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .II, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                            "aria-label": field.name,
                            autoComplete: htmlInputType === "password" ? "current-password" : "off",
                            "data-testid": id,
                            isDisabled: isDisabled,
                            name: field.name,
                            onChange: field.onChange,
                            placeholder: placeholder,
                            sx: {
                                color: "heading",
                                fontWeight: "medium",
                                fontSize: "1rem"
                            },
                            type: htmlInputType || "text",
                            value: field.value
                        }, fieldStyles.input));
                    }
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_utils_IsVisible__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    when: !!errorMessage,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_brand_components__WEBPACK_IMPORTED_MODULE_1__/* .FormErrorMessage */ .J1, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        justifyContent: "flex-end",
                        textAlign: "right"
                    }, fieldStyles.errorMessage), {
                        children: t("validations.".concat(errorMessage))
                    }))
                })
            ]
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TextField);


/***/ }),

/***/ 86778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ form_UploadFileField; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(37328);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(76699);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../node_modules/react-icons/fi/index.esm.js
var fi_index_esm = __webpack_require__(34543);
// EXTERNAL MODULE: ../../brand/components/index.ts + 96 modules
var components = __webpack_require__(18381);
// EXTERNAL MODULE: ./src/helpers/changeFileProperties.ts
var changeFileProperties = __webpack_require__(48386);
// EXTERNAL MODULE: ../../node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(6804);
// EXTERNAL MODULE: ./src/validators/index.ts + 5 modules
var validators = __webpack_require__(86681);
// EXTERNAL MODULE: ./src/hooks/form/useErrorMessage.ts
var useErrorMessage = __webpack_require__(41217);
// EXTERNAL MODULE: ./src/hooks/form/useStyles.ts
var useStyles = __webpack_require__(16567);
// EXTERNAL MODULE: ./src/components/utils/IsVisible/index.tsx
var IsVisible = __webpack_require__(92238);
// EXTERNAL MODULE: ./src/components/utils/Toast/index.ts + 4 modules
var Toast = __webpack_require__(42344);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react-cropper/dist/react-cropper.es.js
var react_cropper_es = __webpack_require__(21551);
// EXTERNAL MODULE: ./src/helpers/index.ts + 7 modules
var helpers = __webpack_require__(49531);
// EXTERNAL MODULE: ../../node_modules/cropperjs/dist/cropper.css
var cropper = __webpack_require__(12979);
;// CONCATENATED MODULE: ./src/components/molecules/form/UploadFileField/Cropper/index.tsx









var UploadFileFieldCropper = function(param) {
    var handleRemoveImage = param.handleRemoveImage, imageUrl = param.imageUrl, name = param.name, setFieldValue = param.setFieldValue;
    var ref = (0,react.useState)(imageUrl), imageSrc = ref[0], setImageSrc = ref[1];
    var previewImageRef = (0,react.useRef)({});
    var handleCropImage = (0,react.useCallback)((0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var cropper, imgFile, blobImage;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cropper = previewImageRef.current.cropper;
                    if (!cropper) {
                        _ctx.next = 8;
                        break;
                    }
                    imgFile = cropper.getCroppedCanvas().toDataURL();
                    setImageSrc(imgFile);
                    _ctx.next = 6;
                    return helpers/* default.dataUrlToFile */.Z.dataUrlToFile({
                        dataUrl: imageSrc,
                        fileName: "".concat((0,v4/* default */.Z)().slice(0, 4), ".png")
                    });
                case 6:
                    blobImage = _ctx.sent;
                    setFieldValue(name, blobImage);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), [
        setFieldValue,
        name,
        imageSrc
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
                maxHeight: "400px",
                mx: "auto",
                my: "1rem",
                width: "300px",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react_cropper_es/* Cropper */.f, {
                    autoCropArea: 1,
                    background: true,
                    draggable: false,
                    guides: false,
                    ref: previewImageRef,
                    src: imageSrc,
                    style: {
                        height: 400,
                        width: "100%"
                    },
                    toggleDragModeOnDblclick: false,
                    viewMode: 2
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Flex */.kC, {
                columnGap: 2,
                justify: "center",
                mt: 4,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Button */.zx, {
                        fontSize: "14px",
                        onClick: handleRemoveImage,
                        padding: "8px 16px",
                        size: "sm",
                        type: "button",
                        variant: "gray",
                        children: "Remove"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Button */.zx, {
                        fontSize: "14px",
                        onClick: handleCropImage,
                        padding: "8px 16px",
                        size: "sm",
                        type: "button",
                        variant: "solidBlue",
                        children: "Crop image"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Cropper = (UploadFileFieldCropper);

// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/molecules/form/UploadFileField/MultipleImagesLayout/index.tsx




var MultipleImagesLayout = function(param) {
    var file = param.file, fileIndex = param.fileIndex, removeSelectedImage = param.removeSelectedImage;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Flex */.kC, {
        align: "center",
        direction: "column",
        justify: "center",
        p: 4,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                borderRadius: "lg",
                h: "130px",
                position: "relative",
                w: "130px",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                    alt: file,
                    layout: "fill",
                    src: file
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Button */.zx, {
                fontSize: "14px",
                mt: "5px",
                onClick: function() {
                    var fileSelectedIndex = fileIndex;
                    return removeSelectedImage(fileSelectedIndex);
                },
                padding: "8px 16px",
                size: "sm",
                type: "button",
                variant: "gray",
                children: "Remove file"
            })
        ]
    }, file);
};
/* harmony default export */ var UploadFileField_MultipleImagesLayout = (MultipleImagesLayout);

// EXTERNAL MODULE: ../../node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(951);
;// CONCATENATED MODULE: ./src/constants/files.ts
var MAX_FILE_SIZE = 10485760; // # 10MB in bytes

;// CONCATENATED MODULE: ./src/helpers/checkFilesSize.ts

function isFileSizeValid(file) {
    if (file.size > MAX_FILE_SIZE) {
        return false;
    }
    return true;
}
/* harmony default export */ var checkFilesSize = (isFileSizeValid);

;// CONCATENATED MODULE: ./src/components/molecules/form/UploadFileField/index.tsx



















var UploadFileField = function(param) {
    var isDisabled = param.isDisabled, defaultValue = param.defaultValue, field = param.field, id = param.id, name = param.name, setMoreThanTwoFilesUploaded = param.setMoreThanTwoFilesUploaded;
    var isRequired = field.isRequired, shouldDisplay = field.shouldDisplay, _styles = field.styles, styles = _styles === void 0 ? {} : _styles, value = field.value;
    var fieldStyles = (0,useStyles/* useStyles */.y)("textField", styles);
    var t = (0,useTranslation/* useTranslation */.$)([
        "form",
        "common",
        "intervention"
    ]).t;
    var ref = (0,index_esm/* useFormContext */.Gc)(), setValue = ref.setValue, watch = ref.watch, reset = ref.reset;
    var errorMessage = (0,useErrorMessage/* useErrorMessage */.f)(name);
    var ref1 = (0,react.useState)(false), fileTypesErrorMessage = ref1[0], setFileTypesErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(false), filesAmountError = ref2[0], setFilesAmountError = ref2[1];
    var ref3 = (0,react.useState)(false), fileSizeError = ref3[0], setFileSizeError = ref3[1];
    var values = watch(name);
    var ref4 = (0,react.useState)([]), fileUploadedType = ref4[0], setFileUploadedType = ref4[1];
    var ref5 = (0,react.useState)([]), documentsUploaded = ref5[0], setDocumentsUploaded = ref5[1];
    var ref6 = (0,react.useState)([]), photosUploaded = ref6[0], setPhotosUploaded = ref6[1];
    (0,react.useEffect)(function() {
        // handle Select Input in parent component
        if (documentsUploaded.length > 1 || photosUploaded.length > 1) {
            setMoreThanTwoFilesUploaded === null || setMoreThanTwoFilesUploaded === void 0 ? void 0 : setMoreThanTwoFilesUploaded(true);
        }
        return function() {
            setMoreThanTwoFilesUploaded === null || setMoreThanTwoFilesUploaded === void 0 ? void 0 : setMoreThanTwoFilesUploaded(false);
        };
    }, [
        documentsUploaded,
        photosUploaded,
        setMoreThanTwoFilesUploaded
    ]);
    var handleEventListener = (0,react.useCallback)(function(data) {
        var ref;
        if ((ref = data.uploadRef.current) === null || ref === void 0 ? void 0 : ref.files) {
            var files = data.uploadRef.current.files;
            var filesArray = Array.from(files).map(function(file) {
                var res = (0,changeFileProperties/* default */.Z)(file, "".concat((0,v4/* default */.Z)().slice(0, 4)).concat(file.name.toLowerCase()));
                return res;
            });
            // Check if any of the files are bigger than 10MB
            var oversizedFileName = "";
            var hasInvalidSize = filesArray.some(function(file) {
                if (!checkFilesSize(file)) {
                    oversizedFileName = file.name.substring(0, 10);
                    return true;
                }
                return false;
            });
            if (hasInvalidSize) {
                setFileSizeError(true);
                return;
            }
            // -- allow only 1 file type by upload
            var uploadedFileTypes = {
                pdf: false,
                image: false
            };
            var multipleFileTypesUploaded = filesArray.map(function(file) {
                if (file.type.toLowerCase().includes("pdf")) {
                    uploadedFileTypes.pdf = true;
                }
                if (file.type.toLowerCase().includes("image")) {
                    uploadedFileTypes.image = true;
                }
                return uploadedFileTypes.pdf === true && uploadedFileTypes.image === true;
            });
            if (multipleFileTypesUploaded && uploadedFileTypes.pdf && uploadedFileTypes.image) {
                setFileTypesErrorMessage(true);
                return;
            }
            // allow only up to 4 documents upload at a time
            if (filesArray.length > 4) {
                setFilesAmountError(true);
                return;
            }
            var imagesUrl = [];
            filesArray.forEach(function(file) {
                if (file) {
                    setFileUploadedType(function(prevState) {
                        return prevState.concat(file.type);
                    });
                    var fileVerified = validators/* default.fileType */.Z.fileType(file === null || file === void 0 ? void 0 : file.type);
                    // check if file type is accepted
                    if (!fileVerified) {
                        (0,Toast/* default */.Z)({
                            title: "File type incorrect",
                            type: "warning"
                        });
                        return;
                    }
                    if ((file === null || file === void 0 ? void 0 : file.type) === "application/pdf") {
                        setDocumentsUploaded(filesArray);
                        setValue(name, filesArray);
                    } else {
                        var reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = function(event) {
                            var ref;
                            imagesUrl.push((ref = event.target) === null || ref === void 0 ? void 0 : ref.result);
                            setPhotosUploaded(imagesUrl);
                            setValue(name, filesArray);
                        };
                    }
                }
            });
        }
    }, [
        name,
        setValue
    ]);
    (0,react.useEffect)(function() {
        if (fileTypesErrorMessage) {
            (0,Toast/* default */.Z)({
                title: t("intervention:documents.fileTypesError"),
                type: "warning"
            });
            setFileTypesErrorMessage(false);
        }
        if (filesAmountError) {
            (0,Toast/* default */.Z)({
                title: t("intervention:documents.filesAmountError"),
                type: "warning"
            });
            setFilesAmountError(false);
        }
        if (fileSizeError) {
            (0,Toast/* default */.Z)({
                title: t("intervention:documents.filesSizeError"),
                type: "warning"
            });
            setFileSizeError(false);
        }
        reset();
    }, [
        fileSizeError,
        fileTypesErrorMessage,
        t,
        filesAmountError
    ]);
    var uploadFileRef = (0,react.useRef)({});
    var handleUploadFile = (0,react.useCallback)(function(data) {
        data.uploadRef.current.click();
        data.uploadRef.current.addEventListener("change", function() {
            return handleEventListener(data);
        });
        data.uploadRef.current.removeEventListener("change", function() {
            return handleEventListener(data);
        });
    }, [
        handleEventListener
    ]);
    var handleRemoveFile = (0,react.useCallback)(function() {
        setValue(name, undefined);
        setDocumentsUploaded([]);
        setPhotosUploaded([]);
        setFileUploadedType([]);
    }, [
        name,
        setValue
    ]);
    var isVisible = (0,react.useMemo)(function() {
        return shouldDisplay ? shouldDisplay(values) : true;
    }, [
        values,
        shouldDisplay
    ]);
    var cropperIsVisible = (0,react.useMemo)(function() {
        var imageFileOptions = [
            "image/png",
            "image/jpg",
            "image/jpeg"
        ];
        var isFileType = imageFileOptions.some(function(option) {
            return fileUploadedType.find(function(type) {
                return option === type;
            });
        });
        var isVisible = photosUploaded.length === 1 && isFileType;
        return isVisible;
    }, [
        fileUploadedType,
        photosUploaded.length
    ]);
    var removeSelectedImage = (0,react.useCallback)(function(fileIndex) {
        photosUploaded.filter(function(_, index) {
            return index !== fileIndex;
        });
        var filteredFilesUploaded = photosUploaded.filter(function(e) {
            return photosUploaded.indexOf(e) !== fileIndex;
        });
        setValue(name, values.filter(function(_, index) {
            return index !== fileIndex;
        }));
        setPhotosUploaded(filteredFilesUploaded);
    }, [
        name,
        photosUploaded,
        setValue,
        values
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsVisible/* default */.Z, {
        when: isVisible,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* FormControl */.NI, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            isInvalid: !!errorMessage,
            isRequired: isRequired
        }, fieldStyles.control), {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Box */.xu, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsVisible/* default */.Z, {
                            when: !documentsUploaded.length && !photosUploaded.length && !isDisabled,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                                alignItems: "center",
                                display: "flex",
                                justifyContent: "center",
                                my: 6,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Button */.zx, {
                                    height: "7rem",
                                    onClick: function() {
                                        return handleUploadFile({
                                            uploadRef: uploadFileRef
                                        });
                                    },
                                    padding: "0",
                                    type: "button",
                                    variant: "gray",
                                    width: "7rem",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Input */.II, (0,_object_spread/* default */.Z)({
                                            accept: "image/png, image/jpg, image/jpeg, application/pdf",
                                            "aria-label": name,
                                            "data-testid": id,
                                            defaultValue: defaultValue || "",
                                            multiple: true,
                                            ref: uploadFileRef,
                                            sx: {
                                                display: "none"
                                            },
                                            type: "file",
                                            value: value
                                        }, fieldStyles.input)),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(fi_index_esm/* FiPlus */.OvN, {
                                            size: 60
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsVisible/* default */.Z, {
                            when: !!isDisabled,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Flex */.kC, {
                                p: 4,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Icon */.JO, {
                                        as: ai_index_esm/* AiOutlineWarning */.SR5,
                                        w: 6,
                                        h: 6,
                                        color: "primary.base",
                                        m: 2
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Text */.xv, {
                                        pt: 1,
                                        size: "sm",
                                        children: t("form:validations.invalidInterventionType")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsVisible/* default */.Z, {
                            when: !!documentsUploaded.length && !photosUploaded.length,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Box */.xu, {
                                alignItems: "center",
                                display: "flex",
                                flexDirection: "column",
                                flexWrap: "wrap",
                                justifyContent: "center",
                                my: 6,
                                children: [
                                    documentsUploaded.map(function(document) {
                                        var ref;
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Box */.xu, {
                                            bg: "heading",
                                            borderRadius: 6,
                                            mb: 6,
                                            padding: "8px 16px",
                                            width: "280px",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Flex */.kC, {
                                                columnGap: 4,
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(fi_index_esm/* FiFileText */.NOg, {
                                                        color: "white",
                                                        size: 22
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(components/* Text */.xv, {
                                                        color: "white",
                                                        size: "md",
                                                        children: [
                                                            (ref = document) === null || ref === void 0 ? void 0 : ref.name.substring(0, 18),
                                                            document.name.length > 20 && " (...)"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, document.name);
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Button */.zx, {
                                        fontSize: "14px",
                                        onClick: handleRemoveFile,
                                        padding: "8px 16px",
                                        size: "sm",
                                        type: "button",
                                        variant: "gray",
                                        children: t("common:generic.delete")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IsVisible/* default */.Z, {
                            when: !!photosUploaded.length && !documentsUploaded.length,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* Flex */.kC, {
                                    align: "center",
                                    justify: "center",
                                    m: 6,
                                    wrap: "wrap",
                                    children: photosUploaded.map(function(file, index) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsVisible/* default */.Z, {
                                            when: !cropperIsVisible,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(UploadFileField_MultipleImagesLayout, {
                                                file: file,
                                                fileIndex: index,
                                                removeSelectedImage: removeSelectedImage
                                            })
                                        }, (0,v4/* default */.Z)());
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsVisible/* default */.Z, {
                                    when: cropperIsVisible,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cropper, {
                                        handleRemoveImage: handleRemoveFile,
                                        imageUrl: photosUploaded[0],
                                        name: name,
                                        setFieldValue: setValue
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IsVisible/* default */.Z, {
                    when: !!errorMessage,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components/* FormErrorMessage */.J1, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        justifyContent: "center",
                        textAlign: "center"
                    }, fieldStyles.errorMessage), {
                        children: t("validations.".concat(errorMessage))
                    }))
                })
            ]
        }))
    });
};
/* harmony default export */ var form_UploadFileField = (UploadFileField);


/***/ }),

/***/ 41217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ useErrorMessage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63955);


var useErrorMessage = function(name, label) {
    var formState = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useFormContext */ .Gc)().formState;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var error = formState.errors[name];
        if (!error) {
            return undefined;
        }
        var message = error.message;
        if (message) {
            return String(message).replace(name, label || name);
        }
        return "Field validation failed";
    }, [
        formState.errors,
        name,
        label
    ]);
};


/***/ }),

/***/ 16567:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ StyleCtx; },
/* harmony export */   "y": function() { return /* binding */ useStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37328);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);


var StyleCtx = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var useStyles = function(type, inlineStyles) {
    var baseStyles = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StyleCtx);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return inlineStyles ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, baseStyles[type], inlineStyles) : baseStyles[type];
    }, [
        type,
        baseStyles,
        inlineStyles
    ]);
};


/***/ })

}]);